import { setLogLevel } from "@ostack.tech/kform";

declare global {
  /**
   * Sets the logging level associated with KForm's form managers.
   *
   * This global function is only available in non-production environments.
   * Import {@link setLogLevel} from `@ostack.tech/kform` directly otherwise.
   */
  var setKFormLogLevel: typeof setLogLevel | undefined;
}

// When not in production, expose a way of changing KForm's log level from the
// browser dev tools
if (process.env.NODE_ENV !== "production") {
  globalThis.setKFormLogLevel ??= setLogLevel;
}
